import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  itemAnalytics: [],
  isLoadingAnalytics: false,
  errorAnalytics: false,

  itemOverdueInvoice: [],
  isLoadingItemOverdueInvoice: false,
  errorItemOverdueInvoice: false,

  itemUpcomingInvoice: [],
  isLoadingItemUpcomingInvoice: false,
  errorItemUpcomingInvoice: false,

  itemRoadMap: [],
  isLoadingItemRoadMap: false,
  errorItemRoadMap: false,

  itemTimePerf: [],
  isLoadingTimePerf: false,
  errorTimePerf: false,

  itemSavings: [],
  isLoadingSavings: false,
  errorSavings: false,

  itemSpendingYTD: [],
  isLoadingSpendingYTD: false,
  errorSpendingYTD: false,

  itemTodo: [],
  isLoadingItemTodo: false,
  errorItemTodo: false,

  itemTodoAll: [],
  isLoadingItemTodoAll: false,
  errorItemTodoAll: false,

  updateIsReadTodo: {},
  isLoadingUpdateIsReadTodo: false,
  errorUpdateIsReadTodo: false,

  itemNotif: [],
  isLoadingItemNotif: false,
  errorItemNotif: false,

  itemNotifAll: [],
  isLoadingItemNotifAll: false,
  errorItemNotifAll: false,

  updateIsReadNotif: {},
  isLoadingUpdateIsReadNotif: false,
  errorUpdateIsReadNotif: false,

  getCredit: {},
  errorGetCredit: false,
  isLoadingGetCredit: false,

  getRoadmapCountry: [],
  isLoadingGetRoadMapCountry: false,
  errorGetRoadMapCountry: false

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/index.js